import Vue from 'vue'
import store from '../store/index.js'
import Router from 'vue-router'
import { getLocalStore, removeLocalStore } from '../store/utils/storage.js'
import { appWhitelist } from '../store/utils/app_whitelist.js'
import { funcId } from '../store/utils/func_id_list.js'
import * as auth from '../api/auth/index.js'
import * as restrictAccess from '../api/restrict_access/index.js'
import * as userApi from '../api/user/index.js'
import { authUrl, myUrl, appName } from '../../config/env.js'
const setToken = () => import('../components/auth/SetToken.vue')
const unsupported = () => import('../components/common/Unsupported.vue')
const logout = () => import('../components/auth/Logout.vue')
const app = () => import('../components/App.vue')
const top = () => import('../components/top/Top.vue')
const test = () => import('../components/test/Test.vue')
const group = () => import('../components/master/group/search/Group.vue')
const groupDetail = () => import('../components/master/group/detail/Detail.vue')
const groupEdit = () => import('../components/master/group/detail/Edit.vue')
const category = () => import('../components/master/category/Category.vue')
const categoryEdit = () => import('../components/master/category/CategoryEdit.vue')
const user = () => import('../components/master/user/User.vue')
const userEdit = () => import('../components/master/user/UserEdit.vue')
const training = () => import('../components/training/search/Training.vue')
const trainingRegister = () => import('../components/training/register/Register.vue')
const trainingEdit = () => import('../components/training/register/Edit.vue')
const trainingPreview = () => import('../components/training/register/Preview.vue')
const trainingRecord = () => import('../components/training/record/TrainingRecord.vue')
const trainingResult = () => import('../components/training/record/TrainingResult.vue')
const takeTraining = () => import('../components/training/detail/TakeTraining.vue')
const trainingOverview = () => import('../components/training/detail/Training.vue')
const exam = () => import('../components/exam/search/Exam.vue')
const examRegister = () => import('../components/exam/register/Register.vue')
const examEdit = () => import('../components/exam/register/Edit.vue')
const examPreview = () => import('../components/exam/register/Preview.vue')
const examRecord = () => import('../components/exam/record/ExamRecord.vue')
const takeExam = () => import('../components/exam/detail/TakeExam.vue')
const examOverview = () => import('../components/exam/detail/Exam.vue')
const examResult = () => import('../components/exam/record/ExamResult.vue')
const replicationRegister = () => import('../components/replication/register/Register.vue')
const replicationEdit = () => import('../components/replication/register/Edit.vue')
const replicationTraining = () => import('../components/replication/replicationTraining/search/ReplicationTraining.vue')
const replicationTrainingOverview = () => import('../components/replication/replicationTraining/detail/ReplicationTraining.vue')
const trainingPreparation = () => import('../components/replication/replicationTraining/detail/TrainingPreparation.vue')
const replicationExam = () => import('../components/replication/replicationExam/search/ReplicationExam.vue')
const replicationExamOverview = () => import('../components/replication/replicationExam/detail/ReplicationExam.vue')
const examPreparation = () => import('../components/replication/replicationExam/detail/ExamPreparation.vue')
const questionList = () => import('../components/replication/replicationExam/detail/grading/QuestionList.vue')
const grading = () => import('../components/replication/replicationExam/detail/grading/Grading.vue')
const unadministeredRegister = () => import('../components/replication/register/UnadministeredRegister.vue')

Vue.use(Router)

var router = new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/setToken/:shainNo/:tokenId',
      name: 'setToken',
      component: setToken,
      meta: {
        unnecessaryAuth: true,
        unnecessaryToken: true
      }
    },
    {
      path: '/unsupported',
      name: 'unsupported',
      component: unsupported,
      meta: {
        unnecessaryAuth: true,
        unnecessaryToken: true
      }
    },
    {
      path: '/logout',
      name: 'logout',
      component: logout,
      meta: {
        unnecessaryAuth: true
      }
    },
    {
      path: '/',
      component: app,
      redirect: 'top',
      children: [
        {
          path: 'top',
          component: top,
          meta: {
            unnecessaryAuth: true
          }
        },
        {
          path: '/group',
          component: group,
          meta: {
            menu: funcId.group
          }
        },
        {
          path: 'test',
          component: test,
          meta: {
            unnecessaryAuth: true,
            unnecessaryToken: true
          }
        },
        {
          path: '/groupDetail/:hash',
          component: groupDetail,
          meta: {
            menu: funcId.group
          }
        },
        {
          path: '/groupEdit/:hash',
          component: groupEdit,
          meta: {
            menu: funcId.groupEdit
          }
        },
        {
          path: '/category',
          component: category,
          meta: {
            menu: funcId.category
          }
        },
        {
          path: '/categoryEdit/:hash',
          component: categoryEdit,
          meta: {
            menu: funcId.categoryEdit
          }
        },
        {
          path: '/user',
          component: user,
          meta: {
            menu: funcId.user
          }
        },
        {
          path: '/userEdit/:hash',
          component: userEdit,
          meta: {
            menu: funcId.userEdit
          }
        },
        {
          path: '/training',
          component: training,
          meta: {
            menu: funcId.training
          }
        },
        {
          path: '/trainingRegister',
          component: trainingRegister,
          meta: {
            menu: funcId.trainingRegister
          }
        },
        {
          path: '/trainingEdit/:hash',
          component: trainingEdit,
          meta: {
            menu: funcId.trainingEdit
          }
        },
        {
          path: '/trainingPreview',
          component: trainingPreview,
          meta: {
            menu: funcId.trainingRegister
          }
        },
        {
          path: '/trainingRecord',
          component: trainingRecord,
          meta: {
            menu: funcId.trainingRecord
          }
        },
        {
          path: '/trainingRecord/trainingResult/:id',
          component: trainingResult,
          meta: {
            menu: funcId.trainingRecord
          }
        },
        {
          path: '/training/takeTraining/:hash',
          component: takeTraining,
          meta: {
            menu: funcId.training
          }
        },
        {
          path: '/training/trainingOverview/:hash',
          component: trainingOverview,
          meta: {
            menu: funcId.training
          }
        },
        {
          path: '/exam',
          component: exam,
          meta: {
            menu: funcId.exam
          }
        },
        {
          path: '/examRecord',
          component: examRecord,
          meta: {
            menu: funcId.examRecord
          }
        },
        {
          path: '/examRegister',
          component: examRegister,
          meta: {
            menu: funcId.examRegister
          }
        },
        {
          path: '/examPreview',
          component: examPreview,
          meta: {
            menu: funcId.examRegister
          }
        },
        {
          path: '/examEdit/:hash',
          component: examEdit,
          meta: {
            menu: funcId.examEdit
          }
        },
        {
          path: '/exam/takeExam/:hash',
          component: takeExam,
          meta: {
            menu: funcId.exam
          }
        },
        {
          path: '/exam/examOverview/:hash',
          component: examOverview,
          meta: {
            menu: funcId.exam
          }
        },
        {
          path: '/examRecord/examResult/:id',
          component: examResult,
          meta: {
            menu: funcId.examRecord
          }
        },
        {
          path: '/replicationRegister',
          component: replicationRegister,
          meta: {
            menu: funcId.replicationRegister
          }
        },
        {
          path: '/replicationEdit/:hash',
          component: replicationEdit,
          meta: {
            menu: funcId.replicationEdit
          }
        },
        {
          path: '/replicationTraining',
          component: replicationTraining,
          meta: {
            menu: funcId.replicationTraining
          }
        },
        {
          path: '/replicationTraining/:replicationHash/:trainingHash',
          component: replicationTrainingOverview,
          meta: {
            menu: funcId.replicationTraining
          }
        },
        {
          path: '/training/trainingPreparation/:replicationHash/:trainingHash',
          component: trainingPreparation,
          meta: {
            menu: funcId.training
          }
        },
        {
          path: '/replicationExam',
          component: replicationExam,
          meta: {
            menu: funcId.replicationExam
          }
        },
        {
          path: '/replicationExam/:replicationHash/:examHash',
          component: replicationExamOverview,
          meta: {
            menu: funcId.replicationExam
          }
        },
        {
          path: '/exam/examPreparation/:replicationHash/:examHash',
          component: examPreparation,
          meta: {
            menu: funcId.exam
          }
        },
        {
          path: '/replicationExam/questionList/:replicationId/:examHash',
          component: questionList,
          meta: {
            menu: funcId.replicationExamScoring
          }
        },
        {
          path: '/replicationExam/grading/:replicationId/:questionId',
          component: grading,
          meta: {
            menu: funcId.replicationExamScoring
          }
        },
        {
          path: '/UnadministeredRegister/:id',
          component: unadministeredRegister,
          meta: {
            menu: funcId.unadministeredRegister
          }
        }
      ]
    },
    {
      path: '*',
      redirect: 'top'
    }
  ]
})

// ログイン認証
router.beforeEach(async (to, from, next) => {
  // ユーザエージェントの取得
  let userAgent = window.navigator.userAgent.toLowerCase()

  // アプリの起動
  appOpen(userAgent)

  // 非対応ブラウザ判定
  if (!unsupportedCheck(to, next, userAgent)) {
    return
  }

  // アプリ利用可能画面判定
  if (!appWhitelistCheck(to, next, userAgent)) {
    return
  }

  // 権限チェック不要ページ以外はフロント権限を確認
  if (!to.meta.unnecessaryAuth) {
    if (!await frontAuthCheck(to.meta.menu, next)) {
      next({ path: '/top' })
      return
    }
  }

  // アクセストークンチェック不要ページは対象ページへ遷移
  if (typeof to.meta.unnecessaryToken !== 'undefined' && to.meta.unnecessaryToken) {
    next()
    return
  }

  restrictAccess.CheckIp(to.path)
    .then((r) => {
      store.commit('forbidden', false)
      store.commit('onLoading', true)
      if (!to.meta.menu) {
        store.dispatch('transition/MENU', 0)
      } else {
        store.dispatch('transition/MENU', to.meta.menu)
      }
      let accessToken = getLocalStore('ACCESS_TOKEN')
      let refreshToken = getLocalStore('REFRESH_TOKEN')
      let shainNo = getLocalStore('SHAIN_NO')
      if (shainNo && accessToken && refreshToken) {
        auth.checkAccessToken(shainNo, accessToken)
          .then((res) => {
            dispatchShainName(shainNo, ['ShainName'])
            next()
          }).catch((res) => {
            let refreshToken = getLocalStore('REFRESH_TOKEN')
            auth.checkRefreshToken(shainNo, refreshToken)
              .then((r) => {
                dispatchShainName(shainNo, ['ShainName'])
                next()
              }).catch((r) => {
                resetRedirect()
              })
          })
      } else {
        resetRedirect()
      }
    })
    .catch((e) => {
      console.log(e)
      store.commit('forbidden', true)
      next()
    })
})

function dispatchShainName (shainNo, name) {
  if (!store.state.auth.shainName) {
    userApi.getShainInfo(Number(shainNo), name)
      .then((r) => {
        store.dispatch('auth/SHAIN_NAME', r.data.ShainName)
      })
      .catch((e) => {
        console.log(e)
      })
  }
}

function appOpen (userAgent) {
  if (userAgent.indexOf(appName.toLowerCase()) === -1) {
    let target = ['iphone', 'android', 'ipad', 'ipod']
    let len = target.length
    for (let i = 0; i < len; ++i) {
      if (userAgent.indexOf(target[i]) > -1) {
        let host = location.hostname
        let path = location.pathname
        let parameter = '?host=' + host + '&path=' + path
        location.href = 'appname://' + appName + parameter
        break
      }
    }
  }
}

function unsupportedCheck (to, next, userAgent) {
  let res = true
  if (userAgent.indexOf('msie') > -1 || userAgent.indexOf('trident') > -1) {
    if (to.path !== '/unsupported') {
      res = false
      next({ path: '/unsupported' })
    }
  }
  return res
}

function appWhitelistCheck (to, next, userAgent) {
  if (userAgent.indexOf(appName.toLowerCase()) === -1 || to.path === '/top') {
    return true
  }
  let res = false
  let split = to.path.split('/')
  let splitLen = split.length
  let x = appWhitelist.length
  for (let a = 0; a < x; ++a) {
    let y = appWhitelist[a].length
    for (let b = 0; b < y; ++b) {
      if (b <= splitLen && split[b + 1] === appWhitelist[a][b]) {
        if (b - 0 === y - 1) {
          res = true
          break
        }
      } else {
        break
      }
    }
    if (res) break
  }
  if (!res) next({ path: '/top' })
  return res
}

async function frontAuthCheck (menu, next) {
  const authList = getLocalStore('AUTH_LIST')
  if (authList == null || authList.indexOf(menu) < 0) {
    return false
  }
  return true
}

function resetRedirect () {
  removeLocalStore('ACCESS_TOKEN')
  removeLocalStore('REFRESH_TOKEN')
  removeLocalStore('SHAIN_NO')
  removeLocalStore('AUTH_ID')
  removeLocalStore('AUTH_LIST')
  store.dispatch('auth/SHAIN_NAME', '')
  let pathname = location.pathname
  location.href = authUrl + '/login?' +
  'url=' + myUrl + '/setToken' + '&transition=' + pathname
}

router.afterEach((to, from) => {
  store.commit('onLoading', false)
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js